module.exports = __webpack_public_path__ + "img/prioritas_vippack_dfod_dg_k.e850414a.png";